import React from "react";
import "./Header.css";
import Icon from "@msi/cobalt-react/icon";
import "bootstrap/dist/css/bootstrap.min.css";
import AboutDropDown from '../AboutDropDown/AboutDropDown';
import UserMenu from "../UserMenu/UserMenu";

const Header = () => {
  return (
    <div className="msi-common-header-root">
      <header className="msi-common-header">
        <div className="msi-common-header-container full-width header-mode-container">
          <div className="msi-common-header-content header-mode-content">
            <div className="msi-common-header-left-plugin-area">
              <div className="msi-common-header-left-content">
                <a className="application-logo overflow-prevent" href="/">
                  <Icon
                    name="ic_emsignia_light"
                    size={30}
                    className="emsignia msi-icon"
                  />
                  <div className="separator ng-star-inserted"></div>
                  <span className="application-name">API Hub</span>
                </a>
              </div>
            </div>
            <div className="msi-common-header-right-plugin-area">
              <div className="msi-common-header-right-content">
                <AboutDropDown />
              </div>
              <div className="msi-common-header-right-content">
                <UserMenu />
              </div>
            </div>
          </div>
        </div>
      </header>
    </div>
  );
};

export default Header;